export default __webpack_public_path__ + "static/media/ic_transfer_avax.6d7a1ef1.svg";